import { render, staticRenderFns } from "./addReport.vue?vue&type=template&id=5cb9e985&scoped=true&"
import script from "./addReport.vue?vue&type=script&lang=js&"
export * from "./addReport.vue?vue&type=script&lang=js&"
import style0 from "./addReport.vue?vue&type=style&index=0&id=5cb9e985&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!C:\\Users\\86177\\AppData\\Roaming\\npm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb9e985",
  null
  
)

export default component.exports